module.exports = __webpack_public_path__ + "static/media/Data_insight_2-2.e242f421.svg";